import React from 'react'
import '../index.css'

/**
 * Parsing a sizeValue as column header
 * @param {object[]} sizes array of objects containing a sizeValue and amount
 */
const getSizeEntries = (sizes) => {
    return (
        <>
            {sizes.map(entry =>
                <th className="numberColumn">{entry.SizeValue}</th>)
            }
        </>
    )
}

/**
 * Parsing a sizeValue string representation as column header
 * @param {string[]} sizeValues string array of sizes
 */
const getStringsSizeEntries = (sizeValues) => {
    return (
        <>
            {sizeValues.map(size =>
                <th className="size-value">{size}</th>)
            }
        </>
    )
}

/**
 * Parsing an articles amounts as columns
 * @param {object[]} sizeEntries array of objects containing a sizeValue and amount
 */
const getSizeNumbers = (sizeEntries) => {
    return (
        <>
            {sizeEntries.map(entry =>
                <td className="numberColumn">{entry.Amount}</td>)
            }
        </>
    )
}

/**
 * Parsing an articles corrected amounts as columns
 * @param {object[]} sizeEntries array of objects containing a correctionAmount
 */
const getCorrectionNumbers = (sizeEntries) => {
    return (
        <>
            {sizeEntries.map(entry =>
                <td className="numberColumn">{(entry.CorrectionAmount > 0 ? "+" : "") + entry.CorrectionAmount}</td>)
            }
        </>
    )
}

/**
 * Calculating the total value of amounts in a size category
 * @param {object[]} sizeEntries array of objects containing a sizeValue and amount
 */
const getTotal = (sizeEntries) => {
    let numbers = sizeEntries.map(entry => parseInt(entry.Amount))
    let total = 0
    numbers.map(number => total = parseInt(total) + parseInt(number))
    return (
        <>
            <td className="numberColumn">{total}</td>
        </>
    )
}

export { getSizeEntries, getSizeNumbers, getCorrectionNumbers, getTotal, getStringsSizeEntries }